import React, { useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';

function HomepageGallery() {
    const [photos, setPhotos] = useState([]);

    useEffect(() => {
        let mounted = true;
        fetch("/gallery/photos")
            .then(response => {
                if (!response.ok) {
                    throw new Error("Gallery request failed");
                }
                return response.json();
            })
            .then(data => {
                if (mounted) setPhotos(data);
            })
            .catch(error => console.error(error));

        return () => { mounted = false; };
    }, []);

    if (photos.length === 0) {
        return <div className="homepage-gallery-empty" aria-live="polite" />;
    }

    return (
        <Carousel 
            showThumbs={true} 
            showStatus={false} 
            autoPlay interval={7000} 
            infiniteLoop
            showIndicators={false}
        >
            {photos.map(photo => (
                <div className="homepage-gallery slide" key={photo.id}>
                    <img src={photo.imageUrl} alt={photo.altText} />
                    {photo.caption && <p className="legend">{photo.caption}</p>}
                </div>
            ))}
        </Carousel>
    );
}

export default HomepageGallery;